import React from "react";
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";

import Login from "../pages/auth/Login";
import SuperAdminRoutes from "./SuperAdminRoutes";
import BranchRoutes from "./BranchRoutes";
import ProtectedRoute from "./ProtectedRoute";

function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>

                {/* =========================
                    PUBLIC
                ========================= */}

                <Route
                    path="/login"
                    element={<Login />}
                />

                {/* =========================
                    SUPER ADMIN
                ========================= */}

                <Route
                    path="/super-admin/*"
                    element={
                        <ProtectedRoute allowedRole="SUPER_ADMIN">
                            <SuperAdminRoutes />
                        </ProtectedRoute>
                    }
                />

                {/* =========================
                    BRANCH ADMIN
                ========================= */}

                <Route
                    path="/branch/*"
                    element={
                        <ProtectedRoute allowedRole="BRANCH_ADMIN">
                            <BranchRoutes />
                        </ProtectedRoute>
                    }
                />

                {/* =========================
                    DEFAULT
                ========================= */}

                <Route
                    path="/"
                    element={
                        <Navigate
                            to="/login"
                            replace
                        />
                    }
                />

                {/* =========================
                    INVALID URL
                ========================= */}

                <Route
                    path="*"
                    element={
                        <Navigate
                            to="/login"
                            replace
                        />
                    }
                />

            </Routes>
        </BrowserRouter>
    );
}

export default AppRoutes;